import { Component, Input, ElementRef, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-text-tooltip',
    templateUrl: './truncated-text-tooltip.component.html',
})
export class TruncatedTextTooltipComponent implements AfterViewInit {
    @Input() text: string = '';
    @Input() maxWidth: string = '120px';

    @ViewChild('textRef') textRef!: ElementRef<HTMLElement>;

    isTruncated: boolean = false;

    constructor(private cdr: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        const element = this.textRef.nativeElement;
        this.isTruncated = element.offsetWidth < element.scrollWidth;
        this.cdr.detectChanges(); // Evita ExpressionChangedAfterItHasBeenCheckedError
    }
}
